import comment1 from "@/assets/comment_1.jpeg";
import comment2 from "@/assets/comment_2.jpeg";
import comment3 from "@/assets/comment_3.jpeg";
import comment4 from "@/assets/comment_4.jpeg";
import comment5 from "@/assets/comment_5.jpeg";
import comment6 from "@/assets/comment_6.jpeg";
import comment7 from "@/assets/comment_7.jpeg";
import comment8 from "@/assets/comment_8.jpeg";

const comments = [comment1, comment2, comment3, comment4, comment5, comment6, comment7, comment8];

const metrics = [
  { value: "73+", label: "Satisfied Clients" },
  { value: "3+", label: "Years Experience" },
  { value: "300+", label: "Completed Orders" },
  { value: "80+", label: "Brands Joined" },
];

const TestimonialsSection = () => {
  const tripled = [...comments, ...comments, ...comments];

  return (
    <section className="py-12 md:py-20 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary mb-2 block">
            Testimonials
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground mb-3">
            What Clients Say About Graphic Lines
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-sm md:text-base">
            Real feedback from businesses that chose Graphic Lines as their growth partner.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-10 md:mb-14 max-w-4xl mx-auto">
          {metrics.map((m) => (
            <div
              key={m.label}
              className="text-center bg-card border border-border rounded-xl md:rounded-2xl p-4 md:p-6 hover:shadow-lg transition-shadow"
            >
              <p className="text-2xl md:text-3xl font-display font-extrabold text-primary">{m.value}</p>
              <p className="text-[10px] md:text-xs text-muted-foreground mt-1 font-medium">{m.label}</p>
            </div>
          ))}
        </div>

        <div className="relative">
          <div className="flex animate-scroll-left gap-4 md:gap-6" style={{ width: `${tripled.length * 280}px` }}>
            {tripled.map((img, i) => (
              <div
                key={i}
                className="w-[240px] md:w-[320px] flex-shrink-0 bg-card border border-border rounded-xl md:rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow"
              >
                <img
                  src={img}
                  alt={`Client testimonial ${(i % comments.length) + 1}`}
                  className="w-full h-auto object-contain rounded-xl md:rounded-2xl"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
